import type { VisibilityState } from "@tanstack/react-table";

/**
 * Jadval holatining brauzerda saqlanadigan qismi — sof funksiyalar.
 *
 * Kalitlar panel prefiksi bilan yoziladi (`aimly-admin:users:columns`): web
 * ilova bilan bir domenda turganda ularning kalitlari bilan to'qnashmasin.
 */
const PREFIX = "aimly-admin";

export const columnsKey = (table: string) => `${PREFIX}:${table}:columns`;
export const filtersKey = (table: string) => `${PREFIX}:${table}:filters`;

/**
 * Saqlangan ustun ko'rinishi. Buzilgan yoki eski formatdagi yozuv sahifani
 * yiqitmaydi — hamma ustun ko'rinadi. Maxfiy rejimda xotiraning o'zi yopiq
 * bo'lishi ham mumkin, o'shanda ham jadval standart ustunlar bilan ochiladi.
 */
export function readVisibility(key: string): VisibilityState {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) return {};
    return Object.fromEntries(
      Object.entries(parsed).filter(([, value]) => typeof value === "boolean"),
    ) as VisibilityState;
  } catch {
    return {};
  }
}

export function writeVisibility(key: string, state: VisibilityState): void {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch {
    // Saqlab bo'lmasa ham tanlov shu sessiyada ishlayveradi.
  }
}

/**
 * Manzildan faqat eslab qolinadigan kalitlar — `keys` tartibida, satr
 * bo'lib. Sahifa raqami bu ro'yxatga kirmaydi: qaytib kelgan odam birinchi
 * sahifadan boshlaydi, filtrlar esa joyida qoladi.
 */
export function pickParams(params: URLSearchParams, keys: readonly string[]): string {
  const picked = new URLSearchParams();
  for (const key of keys) {
    const value = params.get(key);
    if (value) picked.set(key, value);
  }
  return picked.toString();
}

export function readSavedParams(key: string): string {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

/** Bo'sh tanlov — yozuv o'chiriladi: "Tozalash" keyingi safar ham toza ochilsin. */
export function writeSavedParams(key: string, query: string): void {
  try {
    if (query) localStorage.setItem(key, query);
    else localStorage.removeItem(key);
  } catch {
    // Xotira yopiq — filtrlar faqat manzilda qoladi.
  }
}

/** Saqlangan filtrlarni joriy manzil ustiga qo'yadi (boshqa parametrlar saqlanadi). */
export function mergeParams(current: URLSearchParams, saved: string): URLSearchParams {
  const next = new URLSearchParams(current);
  new URLSearchParams(saved).forEach((value, key) => next.set(key, value));
  return next;
}
